import {
  CurrencyUnit,
  DetailRow,
  InvoiceFormData,
  WeightUnit
} from '../models/invoice-upload.interface';

export interface IInvoiceStore {
  formData: InvoiceFormData;
  weightUnit: WeightUnit;
  currencyUnit: CurrencyUnit;
}

export const initialDetailRow: DetailRow = {
  loadNumber: '',
  trailerNumber: '',
  proNumber: '',
  totalHUs: 0,
  totalWeight: { Unit: 'LBS', Value: 0 },
  baseRate: { Unit: 'USD', Value: 0 },
  accessorials: undefined,
  accessorialRate: { Unit: 'USD', Value: 0 }
};

const initialFormData: InvoiceFormData = {
  invoiceNumber: '',
  invoiceDate: '',
  dueDate: '',
  detailRows: [{ ...initialDetailRow }],
  comment: '',
  documentType: undefined,
  document: null
};

export const initialInvoiceState: IInvoiceStore = {
  formData: initialFormData,
  weightUnit: 'LBS',
  currencyUnit: 'USD'
};
